import React from 'react';
import { PropTypes } from 'prop-types';

import { isEmpty } from 'utils/types';
import { Radios } from '@ontruck/orc';

import { constants as paymentDataConstants } from 'utils/paymentData';

import Input from 'components/PaymentData/PaymentMethodSelector/components/Input';
import SepaCheckbox from 'components/PaymentData/PaymentMethodSelector/components/SepaCheckbox';

const PaymentMethodSelector = ({
  className,
  t,
  CardComponent,
  country: { payment_methods, country },
  paymentMethod: { payment_method },
  handlePaymentMethodSelector,
  handleChangePaymentTerm,
  errors,
}) => (
  <div className={className}>
    <h1>{t('PaymentMethodSelector.title')}</h1>
    {!isEmpty(errors) &&
      (errors.payment_method ||
        Object.keys(errors).some(
          (errorKey) =>
            ['number_of_days', 'IBAN', 'SEPA'].indexOf(errorKey) >= 0
        )) && <p className="error">{t('PaymentMethodSelector.error')}</p>}
    <Radios
      girded
      size="XL"
      name="payment_method"
      items={(payment_methods || [])
        .filter(
          (method) =>
            paymentDataConstants.ACTIVE_PAYMENT_METHODS.indexOf(method) >= 0
        )
        .map((paymentMethodKey) => paymentMethodKey?.toLowerCase())
        .map((paymentMethod) => ({
          value: paymentMethod,
          label: (
            <>
              <h2>{t(`PaymentMethodSelector.${paymentMethod}.title`)}</h2>
              <p>{t(`PaymentMethodSelector.${paymentMethod}.info`)}</p>

              {(payment_method || '').toLowerCase() === paymentMethod && (
                <>
                  {paymentDataConstants.PAYMENT_METHOD({ country })[
                    paymentMethod
                  ] &&
                    paymentDataConstants.PAYMENT_METHOD({ country })[
                      paymentMethod
                    ].isCard && <>{CardComponent}</>}
                  {paymentDataConstants.PAYMENT_METHOD({ country })[
                    paymentMethod
                  ] &&
                    paymentDataConstants.PAYMENT_METHOD({ country })[
                      paymentMethod
                    ].fields &&
                    paymentDataConstants.PAYMENT_METHOD({ country })[
                      paymentMethod
                    ].fields.length >= 1 &&
                    paymentDataConstants
                      .PAYMENT_METHOD({ country })
                      [paymentMethod].fields.map((fieldsRow) => (
                        <div className="form-row">
                          {fieldsRow
                            .filter(
                              (fieldRow) =>
                                !(
                                  fieldRow.fieldName === 'payment_day' &&
                                  country !== 'ES'
                                )
                            )
                            .map((field) => (
                              <Input
                                key={field.fieldName}
                                name={field.fieldName}
                                onChange={handleChangePaymentTerm}
                                t={t}
                                isFullWidth={field.isFullWidth}
                                error={errors && errors[field.fieldName]}
                                defaultValue={field.defaultValue}
                              />
                            ))}
                        </div>
                      ))}
                  {paymentDataConstants.PAYMENT_METHOD({ country })[
                    paymentMethod
                  ] &&
                    paymentDataConstants.PAYMENT_METHOD({ country })[
                      paymentMethod
                    ].icon && (
                      <span className="stripe-icon">
                        {paymentDataConstants
                          .PAYMENT_METHOD({ country })
                          [paymentMethod].icon()}
                      </span>
                    )}
                </>
              )}
            </>
          ),
        }))}
      onChange={handlePaymentMethodSelector}
    />

    {(payment_method || '').toLowerCase() === 'direct_debit' && (
      <SepaCheckbox
        t={t}
        onChange={handleChangePaymentTerm}
        error={errors && errors.SEPA}
      />
    )}
  </div>
);

PaymentMethodSelector.propTypes = {
  t: PropTypes.func,
  className: PropTypes.string,
  country: PropTypes.string,
  CardComponent: PropTypes.node,
  paymentMethod: PropTypes.shape({
    payment_method: PropTypes.string,
    payment_term: PropTypes.string,
  }),
  handlePaymentMethodSelector: PropTypes.func,
  handleChangePaymentTerm: PropTypes.func,
  errors: PropTypes.string,
};

PaymentMethodSelector.defaultProps = {
  t: (t) => t,
  className: '',
  country: '',
  CardComponent: null,
  paymentMethod: {
    payment_method: '',
    payment_term: '',
  },
  handlePaymentMethodSelector: () => ({}),
  handleChangePaymentTerm: () => ({}),
  errors: '',
};

export default PaymentMethodSelector;
